export interface BusinessFeature {
  title: string;
  description: string;
  icon: string;
}

export interface BusinessSectionContent {
  title: string;
  body: string;
  list?: string[];
}

export interface BusinessDetail {
  slug: string;
  title: string;
  en: string;
  icon: string;
  category: string;
  summary: string;
  description: string;
  image: string;
  points: string[];
  features: BusinessFeature[];
  sections: BusinessSectionContent[];
}

export const businessDetails: BusinessDetail[] = [
  {
    slug: "kyozai-shuppan",
    title: "教材・出版プロジェクト",
    en: "Publishing & Educational Materials",
    icon: "ri-book-open-line",
    category: "教育・出版",
    summary:
      "美容業界の最新トレンドと理論を体系的にまとめた教材・書籍を発行。美容学校やサロンで広く採用される実践的なテキストを通じて、美容師やエステティシャンの知識習得とスキル向上を支援しています。",
    description:
      "美容業界の最新トレンドと理論を体系的にまとめた教材・書籍を発行。美容学校やサロンで広く採用される実践的なテキストを提供しています。",
    image:
      "https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/biz-kyozai-shuppan.webp",
    points: [
      "美容学校・サロンで広く採用される実践的なテキスト",
      "最新トレンドを反映した継続的な改訂・増補",
      "初心者からプロまで段階的に学べるカリキュラム構成",
      "理論と実技を両立した体系的な教材設計",
    ],
    features: [
      {
        title: "テキスト教材の企画・制作",
        description:
          "美容理論・技術を分かりやすく体系化したテキスト教材を企画から制作まで一貫して手掛けています。図解や写真を多用し、初学者でも理解しやすい構成が特徴です。",
        icon: "ri-book-2-line",
      },
      {
        title: "検定・資格対策教材",
        description:
          "総合美容検定をはじめ、各種資格試験に対応した対策教材を提供。過去問題の分析に基づく傾向対策と実践的な演習問題で合格をサポートします。",
        icon: "ri-award-line",
      },
      {
        title: "サロン向け実務マニュアル",
        description:
          "接客・施術・店舗運営など、サロンの現場ですぐに活用できる実務マニュアルを制作。新人教育やスタッフ研修にも役立つ内容です。",
        icon: "ri-file-list-3-line",
      },
      {
        title: "デジタル教材の展開",
        description:
          "紙媒体に加え、動画やデジタルブックなど、時代に合わせたデジタル教材も展開。いつでもどこでも学べる環境を提供しています。",
        icon: "ri-smartphone-line",
      },
    ],
    sections: [
      {
        title: "出版事業の特徴",
        body: "当社の出版事業は、単なる書籍制作にとどまらず、美容業界の教育現場と密接に連携した実践的な教材づくりを特徴としています。美容学校やサロンの現場の声を反映し、実際の教育・研修にそのまま活用できるクオリティを追求しています。",
        list: [
          "美容教育の第一線で活躍する講師陣による監修",
          "現場ニーズを反映した実践的な内容構成",
          "定期的な改訂による最新情報への対応",
          "検定・資格制度との連動した教材ラインナップ",
        ],
      },
      {
        title: "主な発行物",
        body: "美容師・エステティシャンを目指す方から、すでに現場で活躍するプロフェッショナルまで、幅広い層に向けた教材・書籍を発行しています。",
        list: [
          "美容理論基礎テキスト（ヘア・スキン・メイク）",
          "総合美容検定公式対策教材",
          "サロン実務マニュアルシリーズ",
          "美容トレンド解説マガジン",
          "健康美容に関する専門書",
        ],
      },
    ],
  },
  {
    slug: "shinseihin-ka",
    title: "新製品化プロジェクト",
    en: "Product Development",
    icon: "ri-lightbulb-line",
    category: "商品開発",
    summary:
      "美容商材の企画から製品化までをワンストップで支援。市場調査、商品開発、パッケージデザイン、販売戦略の立案まで、健康・美容分野のヒット商品づくりをトータルにプロデュースします。ヘアケアをはじめとする美容商材の開発・流通ノウハウを活かし、販路拡大とブランド価値の向上をサポートします。",
    description:
      "美容商材の企画から製品化までをワンストップで支援。市場調査から販売戦略まで、ヒット商品づくりをトータルにプロデュースします。",
    image:
      "https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/biz-shinseihin-ka.webp",
    points: [
      "企画から製品化まで一気通貫のワンストップ支援",
      "市場調査・トレンド分析に基づく商品企画",
      "ヘアケアを中心とした美容商材の開発ノウハウ",
      "販路開拓とブランド価値向上のトータルプロデュース",
    ],
    features: [
      {
        title: "市場調査・商品企画",
        description:
          "美容市場のトレンドや消費者ニーズを徹底的に分析し、売れる商品のコンセプト設計を支援します。競合調査やターゲット設定から具体的な企画までをサポートします。",
        icon: "ri-search-eye-line",
      },
      {
        title: "商品開発・試作",
        description:
          "企画コンセプトに基づき、原料選定から処方開発、試作・評価までを支援。品質・安全性・コストのバランスを考慮した商品づくりを実現します。",
        icon: "ri-flask-line",
      },
      {
        title: "パッケージデザイン",
        description:
          "商品の魅力を最大限に引き出すパッケージデザインを提案。ブランドイメージに合わせたデザイン制作と、消費者に選ばれる陳列提案まで行います。",
        icon: "ri-palette-line",
      },
      {
        title: "販売戦略・販路開拓",
        description:
          "発売後の販路拡大とブランド価値向上を支援。既存の流通ネットワークを活用した販路開拓と、効果的なプロモーション戦略を立案します。",
        icon: "ri-rocket-2-line",
      },
    ],
    sections: [
      {
        title: "ワンストップ開発の流れ",
        body: "当社の新製品化プロジェクトは、商品のアイデアをヒット商品へと育て上げるまでを一貫して支援します。各段階で専門スタッフが伴走し、スピーディーかつ確実な製品化を実現します。",
        list: [
          "市場調査・トレンド分析による企画立案",
          "コンセプト設計とターゲット設定",
          "原料選定・処方開発・試作評価",
          "パッケージデザインとブランド構築",
          "販売戦略立案と販路開拓・プロモーション",
        ],
      },
      {
        title: "実績と強み",
        body: "長年にわたり美容商材の開発・流通に携わってきた実績とノウハウを活かし、大手メーカーから新興ブランドまで幅広いパートナー企業の商品開発を支援しています。特にヘアケア商材の分野では高い専門性を有しています。",
        list: [
          "ヘアケア・スキンケア商材の豊富な開発実績",
          "全国の美容サロン・小売店への流通ネットワーク",
          "トレンドを先取りした商品企画力",
          "品質とコストを両立した開発体制",
        ],
      },
    ],
  },
  {
    slug: "kenko-jigyo",
    title: "健康事業プロジェクト",
    en: "Health Business",
    icon: "ri-heart-pulse-line",
    category: "健康・ウェルネス",
    summary:
      "「美しさは健康から」をテーマに、健康と美容を結びつける事業を展開しています。健康セミナーの開催や健康商材の提案を通じて、心身ともに健やかな美しさを追求するライフスタイルを提案。群馬県高崎市を拠点に、地域の健康増進に貢献する取り組みを推進しています。",
    description:
      "「美しさは健康から」をテーマに、健康セミナーや健康商材の提案を通じて、心身ともに健やかな美しさを追求する事業を展開しています。",
    image:
      "https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/biz-kenko-jigyo.webp",
    points: [
      "健康と美容を結びつけるトータルウェルネス提案",
      "地域の健康増進に貢献するセミナー・イベント開催",
      "安全・安心を重視した健康商材の提案",
      "心身ともに健やかなライフスタイルの提案",
    ],
    features: [
      {
        title: "健康セミナーの開催",
        description:
          "美容と健康に関する最新知識を学べるセミナーを定期的に開催。専門家による講演や実践的なワークショップを通じて、健康的な美しさを提案します。",
        icon: "ri-presentation-line",
      },
      {
        title: "健康商材の提案",
        description:
          "内側からの美しさをサポートする健康食品やサプリメントなど、品質にこだわった健康商材を提案。安全性と効果を重視した商品選定を行っています。",
        icon: "ri-capsule-line",
      },
      {
        title: "地域の健康増進活動",
        description:
          "群馬県高崎市を拠点に、地域住民の健康増進に貢献する取り組みを推進。健康イベントや啓発活動を通じて、地域社会とのつながりを大切にしています。",
        icon: "ri-heart-3-line",
      },
      {
        title: "ライフスタイル提案",
        description:
          "食事・運動・睡眠・メンタルケアなど、総合的な視点から健康的なライフスタイルを提案。美しさの土台となる健康づくりをサポートします。",
        icon: "ri-leaf-line",
      },
    ],
    sections: [
      {
        title: "「美しさは健康から」という理念",
        body: "当社の健康事業は、「美しさは健康から」という理念のもとに展開しています。外見の美しさだけでなく、内側からの健康があってこそ真の美しさが生まれるという考えのもと、健康と美容を結びつける商品・サービスを提供しています。",
        list: [
          "内側からの美しさを重視した商品・サービス開発",
          "科学的根拠に基づく健康情報の発信",
          "健康と美容の専門家による監修体制",
          "継続的な健康づくりを支援する仕組み",
        ],
      },
      {
        title: "今後の取り組み",
        body: "高齢化社会や健康志向の高まりを受け、健康事業の重要性はますます高まっています。当社は、地域密着の取り組みをさらに拡大するとともに、オンラインを活用した全国展開も視野に入れ、より多くの方に健康的な美しさを届けていきます。",
        list: [
          "オンライン健康セミナーの拡充",
          "健康商材ラインナップの拡大",
          "医療・福祉分野との連携強化",
          "地域健康イベントの定期開催",
        ],
      },
    ],
  },
  {
    slug: "salon-keiei",
    title: "サロン経営プロジェクト",
    en: "Salon Management",
    icon: "ri-store-2-line",
    category: "サロン経営",
    summary:
      "美容サロンの開業・運営をトータルで支援するプロジェクトです。店舗設計、商材選定、スタッフ採用、集客施策まで、サロン経営に必要なすべてをサポート。開業準備から安定経営まで、経営者様のパートナーとして一貫して伴走します。",
    description:
      "美容サロンの開業・運営をトータルで支援。店舗設計から集客施策まで、開業準備から安定経営まで一貫して伴走します。",
    image:
      "https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/biz-salon-keiei.webp",
    points: [
      "開業準備から安定経営まで一貫したサポート",
      "店舗設計・内装から商材選定までトータル支援",
      "スタッフ採用・育成のノウハウ提供",
      "実績に基づく集客・売上向上施策",
    ],
    features: [
      {
        title: "開業支援",
        description:
          "事業計画の策定から物件選定、資金計画、各種申請手続きまで、美容サロンの開業に必要なすべてをサポート。初めての方でも安心して開業できるよう、丁寧に伴走します。",
        icon: "ri-store-2-line",
      },
      {
        title: "店舗設計・商材選定",
        description:
          "コンセプトに合わせた店舗設計・内装デザインを提案。また、施術内容やターゲットに最適な商材・機器の選定を支援します。",
        icon: "ri-ruler-line",
      },
      {
        title: "スタッフ採用・育成",
        description:
          "採用計画の立案から面接・選考のサポート、研修プログラムの提供まで、人材面の課題をトータルに支援。定着率の向上につながる組織づくりを提案します。",
        icon: "ri-team-line",
      },
      {
        title: "集客・マーケティング",
        description:
          "Web集客、SNS運用、リピーター獲得施策など、効果的な集客・マーケティング戦略を立案。売上向上につながる実践的なノウハウを提供します。",
        icon: "ri-megaphone-line",
      },
    ],
    sections: [
      {
        title: "トータルサポートの流れ",
        body: "当社のサロン経営プロジェクトは、開業を検討している段階から、安定経営を実現するまで、経営者様に寄り添ってサポートします。美容業界の現場を知り尽くしたスタッフが、それぞれの段階に応じた最適な支援を提供します。",
        list: [
          "開業相談・事業計画の策定支援",
          "物件選定・店舗設計・商材選定",
          "スタッフ採用・育成支援",
          "オープン後の集客・経営改善サポート",
        ],
      },
      {
        title: "経営者様へのメッセージ",
        body: "美容サロンの経営は、技術力だけでなく、経営の知識やノウハウも求められる難しい事業です。当社は、長年の経験で培ったノウハウを惜しみなく提供し、経営者様が自信を持って事業に取り組めるよう、全力でサポートいたします。",
        list: [
          "美容業界特有の課題に精通した専門スタッフ",
          "成功事例に基づく実践的なアドバイス",
          "経営者様の想いを尊重したオーダーメイド支援",
          "開業後の継続的なフォローアップ体制",
        ],
      },
    ],
  },
  {
    slug: "salon-keiei-consulting",
    title: "サロン経営コンサルティング",
    en: "Salon Management Consulting",
    icon: "ri-customer-service-2-line",
    category: "コンサルティング",
    summary:
      "美容サロンの経営改善に特化したプロフェッショナルコンサルティングです。集客力の強化、売上向上、人材育成、メニュー設計など、サロン経営のあらゆる課題を分析し、具体的な解決策を提案。実践的なノウハウを提供しています。",
    description:
      "美容サロンの経営改善に特化したコンサルティング。集客・売上・人材などあらゆる課題を分析し、解決策を提供します。",
    image:
      "https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/biz-salon-consulting.webp",
    points: [
      "サロン経営支援の豊富なノウハウ",
      "集客力強化・売上向上・人材育成をトータル支援",
      "経営課題をデータに基づき分析・可視化",
      "具体的なアクションプランを提案・実行支援",
    ],
    features: [
      {
        title: "経営診断・課題分析",
        description:
          "売上データや顧客動向、スタッフ状況などを徹底的に分析し、サロンが抱える本質的な課題を可視化。改善すべきポイントを明確にします。",
        icon: "ri-file-chart-line",
      },
      {
        title: "集客・売上向上支援",
        description:
          "新規集客からリピーター獲得、客単価向上まで、売上アップにつながる具体的な施策を提案。Web・SNSを活用した効果的な集客戦略を立案します。",
        icon: "ri-line-chart-line",
      },
      {
        title: "人材育成・組織づくり",
        description:
          "スタッフのスキルアップやモチベーション向上、離職防止など、人材面の課題を解決。強いチームをつくるための組織づくりを支援します。",
        icon: "ri-user-star-line",
      },
      {
        title: "メニュー・価格設計",
        description:
          "利益率の高いメニュー構成や適切な価格設定を提案。顧客満足度と収益性を両立するメニュー設計をサポートします。",
        icon: "ri-price-tag-3-line",
      },
    ],
    sections: [
      {
        title: "コンサルティングの進め方",
        body: "当社のコンサルティングは、現状の徹底的な分析からスタートします。漠然としたアドバイスではなく、データに基づく具体的な改善策を提案し、実行までを伴走するスタイルが特徴です。",
        list: [
          "ヒアリングによる現状把握と課題の整理",
          "売上・顧客データの分析による課題の可視化",
          "優先順位を明確にした改善計画の策定",
          "施策の実行支援と定期的な効果検証",
        ],
      },
      {
        title: "実践から生まれたノウハウ",
        body: "さまざまな規模・業態のサロンと向き合ってきた経験から、課題解決のための実践的なノウハウが蓄積されています。",
        list: [
          "開業前のサロンから老舗サロンまで幅広く対応",
          "業態別（ヘア・ネイル・エステなど）の専門ノウハウ",
          "成功事例・失敗事例から学ぶ実践的アプローチ",
          "成果にこだわったPDCAサイクルの徹底",
        ],
      },
    ],
  },
  {
    slug: "gakko-school-consulting",
    title: "学校・スクールコンサルティング",
    en: "School Consulting",
    icon: "ri-school-line",
    category: "コンサルティング",
    summary:
      "美容学校・スクールの運営支援に特化したコンサルティングです。カリキュラム設計、講師育成、学生募集、運営改善など、教育機関が抱える課題を解決。学校法人有坂中央学園との連携ノウハウを活かした、実践的な教育支援を提供しています。",
    description:
      "美容学校・スクールの運営支援に特化したコンサルティング。カリキュラム設計から学生募集、運営改善まで、教育機関の課題を解決します。",
    image:
      "https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/biz-gakko-school.webp",
    points: [
      "美容学校・スクールの運営課題をトータル解決",
      "学校法人有坂中央学園との連携ノウハウを活用",
      "カリキュラム設計から学生募集まで幅広く支援",
      "教育の質向上と経営安定の両立を実現",
    ],
    features: [
      {
        title: "カリキュラム設計",
        description:
          "美容業界の最新動向を反映した実践的なカリキュラムを設計。国家試験対策から現場実習まで、就職に強い人材育成のための教育プログラムを構築します。",
        icon: "ri-book-read-line",
      },
      {
        title: "講師育成支援",
        description:
          "教育の質を左右する講師の育成を支援。指導力向上のための研修プログラムや教材提供を通じて、質の高い教育体制の構築をサポートします。",
        icon: "ri-user-heart-line",
      },
      {
        title: "学生募集支援",
        description:
          "少子化による志願者減少という課題に対し、効果的な学生募集戦略を提案。オープンキャンパスやSNS活用など、実践的な集客施策を支援します。",
        icon: "ri-group-line",
      },
      {
        title: "運営改善",
        description:
          "経費削減や業務効率化など、教育機関の経営面の課題を解決。教育の質を維持しながら、持続可能な運営体制の構築を支援します。",
        icon: "ri-settings-3-line",
      },
    ],
    sections: [
      {
        title: "教育機関との連携",
        body: "当社は、学校法人有坂中央学園（高崎ビューティモード専門学校など）との長年にわたる連携を通じて、美容教育の現場で培われた実践的なノウハウを有しています。この経験を活かし、他の教育機関の課題解決を支援しています。",
        list: [
          "美容専門学校との強固な連携体制",
          "教育現場のリアルな課題に精通したコンサルタント",
          "実践的な教育プログラムの共同開発",
          "卒業後のキャリア支援まで見据えた教育設計",
        ],
      },
      {
        title: "美容教育の未来を見据えて",
        body: "美容業界は常に進化しており、求められる人材像も変化しています。当社は、単なる資格取得にとどまらず、美容業界で長く活躍できるプロフェッショナルを育成するための教育支援を追求しています。",
        list: [
          "業界トレンドを先取りした教育プログラム",
          "デジタル技術を活用した教育手法の導入",
          "産学連携による実践的な学びの提供",
          "グローバル人材育成を見据えたカリキュラム",
        ],
      },
    ],
  },
  {
    slug: "school-seminar",
    title: "スクール・セミナープロジェクト",
    en: "School & Seminar",
    icon: "ri-presentation-line",
    category: "教育・セミナー",
    summary:
      "美容業界のプロフェッショナルを育成するためのセミナー・スクールを全国で開催しています。最新の技術と理論を学べる実践的なカリキュラムで、初心者から上級者まで段階的にスキルアップを支援。",
    description:
      "美容業界のプロフェッショナル育成のためのセミナー・スクールを全国で開催。初心者から上級者まで段階的なスキルアップを支援します。",
    image:
      "https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/biz-school-seminar.webp",
    points: [
      "全国で開催するセミナー・スクール",
      "初心者から上級者まで段階的なカリキュラム",
      "最新の技術と理論を学べる実践的な内容",
      "全国での開催とオンライン受講に対応",
    ],
    features: [
      {
        title: "技術セミナー",
        description:
          "カット・カラー・パーマなど、美容技術の最新トレンドを学べる実践的なセミナー。第一線で活躍する講師によるデモンストレーションと実技指導が特徴です。",
        icon: "ri-scissors-line",
      },
      {
        title: "経営セミナー",
        description:
          "サロン経営者向けに、集客・売上・人材育成など経営ノウハウを学べるセミナー。成功事例を交えた実践的な内容で、明日から使える知識が身につきます。",
        icon: "ri-briefcase-line",
      },
      {
        title: "認定スクール",
        description:
          "体系的なカリキュラムで段階的に学べる認定スクール。修了者には認定資格を付与し、キャリアアップを支援します。",
        icon: "ri-graduation-cap-line",
      },
      {
        title: "オンライン講座",
        description:
          "場所や時間を選ばずに学べるオンライン講座を提供。録画配信とライブ配信の両方に対応し、忙しい美容プロフェッショナルの学びを支援します。",
        icon: "ri-vidicon-line",
      },
    ],
    sections: [
      {
        title: "スクール・セミナーの特徴",
        body: "当社のスクール・セミナーは、単なる知識の提供にとどまらず、受講者が現場ですぐに活かせる実践的なスキルを身につけることを重視しています。少人数制のクラスや個別指導など、きめ細かなサポート体制が特徴です。",
        list: [
          "第一線で活躍する講師陣による直接指導",
          "実技中心の実践的なカリキュラム",
          "少人数制によるきめ細かな指導",
          "修了後のフォローアップ体制",
        ],
      },
      {
        title: "開催プログラム",
        body: "技術・経営・接客など、美容業界で活躍するために必要なスキルを幅広くカバーしたプログラムを開催しています。季節やトレンドに合わせたテーマ別セミナーも定期的に開催しています。",
        list: [
          "美容技術の最新トレンドセミナー",
          "サロン経営・マーケティング講座",
          "接客・カウンセリングスキルアップ講座",
          "国家試験対策講座",
          "トレンドヘア・メイク実践講座",
        ],
      },
    ],
  },
  {
    slug: "sogo-biyo-kentei",
    title: "総合美容検定",
    en: "Beauty Certification",
    icon: "ri-award-line",
    category: "検定・資格",
    summary:
      "美容に関する知識・技術を総合的に評価する検定制度です。美容業界で働く方やこれから美容業界を目指す方のスキル向上とキャリア形成を支援。業界標準の資格として認知度を高めています。",
    description:
      "美容の知識・技術を総合的に評価する検定制度。業界標準の資格です。",
    image:
      "https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/biz-sogo-biyo-kentei.webp",
    points: [
      "業界標準としての資格",
      "美容の知識・技術を総合的に評価する検定制度",
      "キャリア形成とスキル向上を強力に支援",
      "就職・転職に有利な資格として認知度が向上",
    ],
    features: [
      {
        title: "段階的なレベル設定",
        description:
          "初級・中級・上級の3段階に分かれたレベル設定で、初心者からプロフェッショナルまで自分のスキルに合わせて挑戦できます。段階的にステップアップすることで確実にスキルを高められます。",
        icon: "ri-stairs-line",
      },
      {
        title: "総合的な知識・技術評価",
        description:
          "ヘア・スキン・メイク・ネイルなど、美容分野の幅広い知識と技術を総合的に評価。バランスの取れた美容プロフェッショナルの育成を目指しています。",
        icon: "ri-task-line",
      },
      {
        title: "キャリア形成支援",
        description:
          "合格者には認定証を発行し、就職・転職時のアピールポイントとして活用できます。履歴書やサロンの求人にも評価される資格として認知度を高めています。",
        icon: "ri-briefcase-4-line",
      },
      {
        title: "対策セミナーの開催",
        description:
          "検定合格に向けた対策セミナーや教材を提供。初めて受検する方でも安心して挑戦できるよう、手厚いサポート体制を整えています。",
        icon: "ri-file-text-line",
      },
    ],
    sections: [
      {
        title: "検定制度の概要",
        body: "総合美容検定は、美容に関する知識・技術を客観的に評価する検定制度です。美容業界で働く方のスキル証明として、また美容業界を目指す方の学習目標として、幅広く活用されています。",
        list: [
          "美容の基礎知識から応用技術までを総合評価",
          "筆記試験と実技試験による多面的な評価",
          "年複数回の試験実施による受検機会の確保",
          "認定校・認定サロンとの連携による普及推進",
        ],
      },
      {
        title: "受検のメリット",
        body: "総合美容検定の合格は、美容プロフェッショナルとしてのスキルを客観的に証明するものです。就職活動やキャリアアップの際の強力なアピールポイントとなります。",
        list: [
          "スキルの客観的な証明による信頼性の向上",
          "就職・転職活動でのアピールポイントに",
          "キャリアアップ・昇給・昇格への足がかりに",
          "体系的な学習によるスキルの底上げ",
        ],
      },
    ],
  },
  {
    slug: "global-project",
    title: "グローバルプロジェクト",
    en: "Global Project",
    icon: "ri-global-line",
    category: "国際展開",
    summary:
      "美容分野における国際的な人材育成と交流を推進するプロジェクトです。海外の美容教育機関との連携や、留学生の受け入れ支援を通じて、美容業界のグローバル化に貢献。世界中の美容プロフェッショナルとのネットワークを構築しています。",
    description:
      "美容分野の国際的な人材育成と交流を推進。海外教育機関との連携や留学生支援を通じて、美容業界のグローバル化に貢献します。",
    image:
      "https://media.genaiweb.ai/73acebca-6391-4da3-b270-472de16380f3/biz-global-project.webp",
    points: [
      "美容分野の国際的な人材育成と交流を推進",
      "海外の美容教育機関との連携ネットワークを構築",
      "留学生の受け入れ支援を実施",
      "世界中の美容プロフェッショナルと連携",
    ],
    features: [
      {
        title: "海外教育機関との連携",
        description:
          "アジアを中心とした海外の美容教育機関と提携し、教育プログラムの相互交流や技術研修を実施。美容技術・教育の国際的な発展に貢献しています。",
        icon: "ri-earth-line",
      },
      {
        title: "留学生受け入れ支援",
        description:
          "海外から美容を学ぶ留学生の受け入れを支援。日本語教育から美容技術の習得、就職支援まで、留学生が日本で活躍するための包括的なサポートを提供します。",
        icon: "ri-plane-line",
      },
      {
        title: "国際交流イベント",
        description:
          "美容技術の国際コンテストや文化交流イベントを開催。世界中の美容プロフェッショナルが交流し、学び合う場を提供しています。",
        icon: "ri-hand-heart-line",
      },
      {
        title: "グローバル人材育成",
        description:
          "海外で活躍できる美容プロフェッショナルの育成を支援。語学研修や海外研修プログラムを通じて、グローバルな視点を持つ人材の育成に取り組んでいます。",
        icon: "ri-user-star-line",
      },
    ],
    sections: [
      {
        title: "グローバル化への取り組み",
        body: "美容業界のグローバル化が進む中、海外との交流や人材育成の重要性はますます高まっています。当社は、美容技術・教育の国際交流を通じて、日本の美容業界のさらなる発展に貢献することを目指しています。",
        list: [
          "アジア各国の美容教育機関との連携強化",
          "美容技術の国際標準化への貢献",
          "海外の美容トレンドを日本へ、日本の技術を海外へ",
          "国際的な美容人材ネットワークの構築",
        ],
      },
      {
        title: "今後の展望",
        body: "今後は、連携国・地域の拡大や、オンラインを活用した国際交流プログラムの充実など、グローバルプロジェクトのさらなる発展を目指しています。世界中の美容プロフェッショナルとつながり、美容業界の未来を共に創っていきます。",
        list: [
          "連携国・地域のさらなる拡大",
          "オンライン国際交流プログラムの充実",
          "海外美容コンテストへの参加・開催支援",
          "国際資格の相互認証に向けた取り組み",
        ],
      },
    ],
  },
];